module.exports = __webpack_public_path__ + "ee0b2d910f45a8b32127e913e9d28669.svg";